import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustStrip } from "@/components/landing/TrustStrip";
import { MadeByAdmins } from "@/components/landing/MadeByAdmins";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ScopeClarity } from "@/components/landing/ScopeClarity";
import { Features } from "@/components/landing/Features";
import { VideoShowcase } from "@/components/landing/VideoShowcase";
import { SavingsCalculator } from "@/components/landing/SavingsCalculator";
import { Cashback } from "@/components/landing/Cashback";
import { Benefits } from "@/components/landing/Benefits";
import { Testimonials } from "@/components/landing/Testimonials";
import { FreeTrial } from "@/components/landing/FreeTrial";
import { MidCTA } from "@/components/landing/MidCTA";
import { LeadForm } from "@/components/landing/LeadForm";
import { FAQ } from "@/components/landing/FAQ";
import { Footer } from "@/components/landing/Footer";
import { useContent } from "@/context/ContentContext";

const REGISTRY = {
  madebyadmins: MadeByAdmins,
  howitworks: HowItWorks,
  scopeclarity: ScopeClarity,
  features: Features,
  video: VideoShowcase,
  savings: SavingsCalculator,
  cashback: Cashback,
  benefits: Benefits,
  testimonials: Testimonials,
  freetrial: FreeTrial,
  midcta: MidCTA,
  leadform: LeadForm,
  faq: FAQ,
};

export default function LandingPage() {
  const { sections } = useContent();
  return (
    <main className="min-h-screen bg-background text-foreground">
      <Navbar />
      <Hero />
      <TrustStrip />
      {sections
        .filter((s) => s.visible !== false)
        .map((s) => {
          const Cmp = REGISTRY[s.id];
          return Cmp ? <Cmp key={s.id} /> : null;
        })}
      <Footer />
    </main>
  );
}
